var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5903_29900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.80441 8.70567H31.9221V5.80371H5.80441C4.20833 5.80371 2.90245 7.10959 2.90245 8.70567V24.6665H0.000488281V29.0194H20.3142V24.6665H5.80441V8.70567ZM33.373 11.6076H24.6672C23.8691 11.6076 23.2162 12.2606 23.2162 13.0586V27.5684C23.2162 28.3665 23.8691 29.0194 24.6672 29.0194H33.373C34.1711 29.0194 34.824 28.3665 34.824 27.5684V13.0586C34.824 12.2606 34.1711 11.6076 33.373 11.6076ZM31.9221 24.6665H26.1181V14.5096H31.9221V24.6665Z",
    fill: "#8F9BB3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5903_29900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.8235,
    height: 34.8235,
    fill: "white",
    transform: "translate(0.000488281)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.c8d17ff9f973abd32324a13df8d00e8f.svg";
export { ForwardRef as ReactComponent };